export enum KBResourceType {
  FILE = 'file',
  URL = 'url',
}

export interface KBResource {
  id: number;
  kb_id: number;
  resource_type: KBResourceType;
  resource_name: string;
  resource_path: string;
  file_size: number | null;
  added_at: string;
}

// KB Tag types for hierarchical organization
export interface KBTagSummary {
  id: number;
  name: string;
  color: string | null;
  full_path: string;  // e.g., "Clients > Sigma"
}

export interface KBTag {
  id: number;
  name: string;
  parent_id: number | null;
  user_id: number;
  color: string | null;
  created_at: string;
  updated_at: string;
  kb_count: number;
}

export interface KBTagTreeNode {
  id: number;
  name: string;
  parent_id: number | null;
  color: string | null;
  kb_count: number;
  children: KBTagTreeNode[];
}

export interface KBTagCreateRequest {
  name: string;
  parent_id?: number | null;
  color?: string | null;
}

export interface KBTagUpdateRequest {
  name?: string;
  parent_id?: number | null;  // 0 means move to root
  color?: string | null;
}

export interface KnowledgeBase {
  id: number;
  title: string;
  description: string | null;
  archived: boolean;
  is_default: boolean;
  created_by: number;
  source_task_id: number | null;
  created_at: string;
  updated_at: string;
  resources: KBResource[];
  tags: KBTagSummary[];
}

export interface KnowledgeBaseListItem {
  id: number;
  title: string;
  description: string | null;
  archived: boolean;
  is_default: boolean;
  created_by: number;
  source_task_id: number | null;
  created_at: string;
  updated_at: string;
  created_by_username?: string;
  created_by_fullname?: string;
  resource_count: number;
  tags: KBTagSummary[];
}

export interface KBCreateRequest {
  title: string;
  description?: string;
}

export interface KBUpdateRequest {
  title?: string;
  description?: string;
}

export interface KBResourceCreateRequest {
  resource_name: string;
  resource_path: string;
}

export interface TaskToKBRequest {
  title: string;
  description?: string;
  include_input_files: boolean;
  include_output_files: boolean;
}
